module.exports = __webpack_public_path__ + "media/images/wedding/top/reason5-3dfa98dfdcc3af78a96cd9d7c1893f60.jpg";